// import styles from './RemovePOI.scss'
import { ConfirmationDialog } from "common/styleguide/ConfirmationDialog";
import React from "react";

// TODO: this should get a fancy green checkmark depending on how the save/redux stuff works

export class RemovePOI extends React.PureComponent {
  render() {
    const { tag, ...props } = this.props;
    return (
      <ConfirmationDialog confirmText="Remove" {...props}>
        Are you sure you want to remove the POI Tag{" "}
        <strong>
          <em>{tag}</em>
        </strong>{" "}
        ?
      </ConfirmationDialog>
    );
  }
}
